import jQuery from 'jquery'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
//import CustomAnimation from '../animation/customAnimation';
import Splide from '@splidejs/splide';
//import { Modal } from 'bootstrap'

let splide1;
let teaserSplide;
let pageRady = false;
//const customAnmation = new CustomAnimation();
//let myModal = new Modal(document.getElementById('newsletterModal'));
let showNewsletter = true;//jQuery('.overview').data('show-newsletter');


class Homepage {
  init() {
    this.initPage();
    this.initTeaserCaroussel();
    this.onScroll();
    this.initParallax();
  }

  initPage = () => {
    $(window).scrollTop(0);
    setTimeout(function () {
      pageRady = true;
    }, 500);

    splide1 = new Splide('.splide_01', {
      type: 'loop',
      perPage: 3,
      focus: 'center',
      autoplay: false,
      flickMaxPages: 3,
      updateOnMove: true,
      pagination: true,
      throttle: 300,
      breakpoints: {
        991: {
          perPage: 2,
          focus: false,
          gap: '1rem',
        },
        768: {
          perPage: 1,
        },
      }
    });
    splide1.mount();
    splide1.refresh();

    setTimeout(function () {

    }, 500);


    // newsletter_close_button
    jQuery('.newsletter_close_button').click(function() {
      jQuery('.newsletter_layer').removeClass('show');
    });
  }

  initTeaserCaroussel = () => {
    teaserSplide = new Splide('.splide_teaser', {
      type: 'loop',
      perPage: 3,
      focus: 'center',
      autoplay: false,
      flickMaxPages: 3,
      updateOnMove: true,
      pagination: true,
      throttle: 300,
      breakpoints: {
        991: {
          perPage: 2,
          focus: false,
          gap: '1rem',
          padding: 0,
        },
        768: {
          perPage: 1,
          focus: 'center',  // Füge focus: 'center' auch für mobile hinzu
          padding: 0,       // Stelle sicher dass padding 0 ist
        },
      },
    });
    teaserSplide.on('moved', function () {
      // Nach Bewegung neu zentrieren
      ///////////teaserSplide.refresh();
    });
    teaserSplide.mount();
    requestAnimationFrame(() => {
      teaserSplide.refresh();
    });


    setTimeout(() => {
      ///////////teaserSplide.refresh();
    }, 100);
  };

  initParallax = () =>  {
    gsap.registerPlugin(ScrollTrigger);

    //customAnmation.animateGroup('.business_boost_box');
    //customAnmation.animateGroup('.overview_box');
    //customAnmation.animateGroup('.clients_video_holder');
    //customAnmation.animateGroup('.blog_teaser_box_holder');


    //customAnmation.animateButtonGroup('.button_holder');
    //customAnmation.animateText('.overview_text_holder');
    //customAnmation.animateGroup('.overview_box_holder');
    //customAnmation.animateButtonHolder('.button_holder_overview');



  }

  onScroll = () => {
    jQuery(window)
      .scroll(function () {
        var newsletterLayerHeight = jQuery('.newsletter_layer_form').height() + 250;
        jQuery('.newsletter_layer').css("height", + newsletterLayerHeight + 'px');

        //var scrollHeight = $(document).height();
        //var scrollPosition = $(window).height() + $(window).scrollTop();
        let positionTop = jQuery('.overview').offset().top - 100;

        //if ((scrollHeight - scrollPosition) / scrollHeight === 0 && showNewsletter == true) {
        if($(window).scrollTop() > positionTop && showNewsletter == true && pageRady == true) {
          jQuery('.newsletter_layer').addClass('show');
          showNewsletter = false;
        }
      }).scroll();
  };
}

export default Homepage;
